import { useEffect, useMemo } from "react";
import { Select, SelectProps, Form } from "antd";

import { useEmployee } from "../../../hook";
import styles from "./ApproverSelect.module.scss";
import { DepartmentCode, branchList } from "../../../constants";
import { eApproveTitleCode } from "../../../constants/bizTitle";

interface Props extends Omit<SelectProps, "options"> {
  fieldUnitName?: string;
  fieldDepartmentName?: string;
  options?: any[];
}

export const ApproverSelect = ({
  fieldUnitName = "eUnit",
  fieldDepartmentName = "eDepartment",
  options,
  ...restProps
}: Props) => {
  const form = Form.useFormInstance();
  const { data: employees } = useEmployee();

  const unit: string | undefined = Form.useWatch(fieldUnitName, form);
  const department: string | undefined = Form.useWatch(
    fieldDepartmentName,
    form
  );

  const unitCode = unit ? unit.split("|")[0] : null;
  const departmentCode = department ? department.split("|")[0] : null;

  const approver = useMemo(() => {
    if (
      unitCode &&
      departmentCode &&
      branchList.includes(departmentCode as DepartmentCode)
    ) {
      return employees.filter(
        (e) =>
          eApproveTitleCode.indexOf(e.eBizTitleCode) > -1 &&
          e.eDepartmentCode === unitCode
      );
    }
    if (
      departmentCode &&
      !branchList.includes(departmentCode as DepartmentCode)
    ) {
      return employees.filter(
        (e) =>
          eApproveTitleCode.indexOf(e.eBizTitleCode) > -1 &&
          e.eDepartmentCode === departmentCode
      );
    }
    return [];
  }, [departmentCode, unitCode, employees]);

  const selectOptions = options ? options : approver;

  useEffect(() => {
    if (department) form.setFieldValue("eApprovedBy", null);
  }, [department, form]);

  return (
    <Select {...restProps} optionLabelProp="label">
      {selectOptions.map((item) => {
        return (
          <Select.Option
            key={item.eEmployeeId}
            value={`${item.eMail}|${item.Title}`}
            label={item.Title}
          >
            <div className={styles.selectItemTitle}>{item.Title}</div>
            <div className={styles.selectItemEmail}>{item.eMail}</div>
          </Select.Option>
        );
      })}
    </Select>
  );
};
